import React, {useEffect, useState} from 'react';
import i18next from 'i18next';
import firebase from "firebase/compat/app";
import "firebase/compat/analytics";
import "firebase/compat/auth";
import "firebase/compat/firestore";
import "firebase/compat/storage";
import "firebase/compat/database";
import { toast } from 'react-toastify';

const ImagePanel = ({campaignUid, characterUid}) => {
  
  const [urlImage, setUrlImage] = useState('');
  const [memberAvailable, setMemberAvailable] = useState([]);

  useEffect(() => {
    if(campaignUid) {
      const dbRefObject = firebase.database().ref('imagePanel').child(`${campaignUid}`);
      dbRefObject.on('value', snap => {
        if(snap.val()) {
          setUrlImage(snap.val().url)
          setMemberAvailable(snap.val().memberAvailable)
        }
      });
      return () => dbRefObject.off();
    }
  }, [campaignUid]);

  return (
    <div className='containerImagePanel'>
      <div className='panelContent' style={{height: window.innerHeight - 180}}>
          {memberAvailable.includes(characterUid) && (
            <img src={urlImage} alt='panelImage'/>
          )}
      </div>
    </div>
  );
  
}

export const ImagePanelAdmin = ({campaignUid, company}) => {
  const [image, setImage] = useState(null);
  const [urlImage, setUrlImage] = useState('');
  const [selectedCharacter, setSelectedCharacter] = useState([]);
  const [selectedCharacterSaved, setSelectedCharacterSaved] = useState([]);
  const [immersive, setImmersive] = useState(false);
  const [sceneActive, setSceneActive] = useState(false);
  const [localPreview, setLocalPreview] = useState('');

  useEffect(() => {
    if(campaignUid) {
      const dbRefObject = firebase.database().ref('imagePanel').child(`${campaignUid}`);
      dbRefObject.on('value', snap => {
        if(snap.val()) {
          setUrlImage(snap.val().url)
          setSelectedCharacterSaved(snap.val().memberAvailable)
          setSceneActive(!!snap.val().immersive)
        }
      });
      return () => dbRefObject.off();
    }
  },[campaignUid]);
  
  useEffect(() => {
    let memberSelected = [];
    for(let i=0; i<selectedCharacterSaved.length; i+=1) {
      memberSelected.push(selectedCharacterSaved[i]);
    }
    setSelectedCharacter(memberSelected);
  }, [selectedCharacterSaved]);

  const publishToNode = (url) => {
    setUrlImage(url);
    firebase.database().ref('imagePanel').child(`${campaignUid}`).set({
      url: url,
      memberAvailable: selectedCharacter,
      immersive: immersive
    });
  };

  const handleUpload = async () => {
    if(image && image.size < 800000){
      const uploadTask = firebase.storage().ref(`panel/${campaignUid}.png`).put(image);
      uploadTask.on(
        "state_changed",
        snapshot => {},
        error => {
          console.log(error);
        },
        async () => {
          await firebase.storage()
            .ref("panel")
            .child(`${campaignUid}.png`)
            .getDownloadURL()
            .then(url => publishToNode(url));
        }
      );
    } else {
      console.log('to big picture');
      toast.error(i18next.t('illustration.sizeMax'), {});
    }
  };

  // Envoie une nouvelle image (upload) ou re-publie l'image existante avec le
  // mode / les destinataires à jour, sans re-uploader.
  const handlePublish = async () => {
    if(!selectedCharacter.length) {
      toast.warning(i18next.t('illustration.needMember'), {});
      return;
    }
    if(image) {
      try { await handleUpload(); }
      catch (error) { console.log('error', error); }
    } else if(urlImage) {
      publishToNode(urlImage);
    } else {
      toast.warning(i18next.t('illustration.needImage'), {});
    }
  };

  const handleChange = async (e) => {
    if (e.target.files[0]) {
      setImage(e.target.files[0]);
      setLocalPreview(URL.createObjectURL(e.target.files[0]));
    }
  };

  const stopScene = () => {
    firebase.database().ref('imagePanel').child(`${campaignUid}`).update({ immersive: false });
  };

  const memberName = (id) => (company.filter((m) => m.uid === id)[0] || {}).name;
  const savedNames = selectedCharacterSaved.map(memberName).filter(Boolean);
  const previewSrc = localPreview || urlImage;

  return (
    <div className='imagePanelAdminContainer'>
      {(sceneActive || (urlImage && savedNames.length > 0)) && (
        <div className={`sceneStatus ${sceneActive ? 'live' : ''}`}>
          <div className='sceneStatusInfo'>
            <span className='sceneStatusBadge'>
              {sceneActive
                ? i18next.t('illustration.statusImmersive')
                : i18next.t('illustration.statusShared')}
            </span>
            {savedNames.length > 0 && (
              <span className='sceneStatusMembers'>{savedNames.join(', ')}</span>
            )}
          </div>
          {sceneActive && (
            <button type="button" className='stopSceneBtn' onClick={stopScene}>
              {i18next.t('illustration.stopScene')}
            </button>
          )}
        </div>
      )}

      <form
        className='sceneForm'
        onSubmit={(e) => { e.preventDefault(); handlePublish(); }}
      >
        {/* Étape 1 : image */}
        <div className='sceneStep'>
          <span className='sceneStepTitle'>{i18next.t('illustration.step1')}</span>
          <label>
            <input type="file" name="file" id="file" className="inputfile" onChange={handleChange} />
            <label htmlFor="file" className='fileBtn'>
              {image ? image.name : i18next.t('choose a file')}
            </label>
          </label>
          {previewSrc && (
            <div className='sceneThumb'>
              <img src={previewSrc} alt='' />
            </div>
          )}
        </div>

        {/* Étape 2 : destinataires */}
        <div className='sceneStep'>
          <span className='sceneStepTitle'>{i18next.t('illustration.step2')}</span>
          <div className='memberActions'>
            <span onClick={() => setSelectedCharacter(company.map((m) => m.uid))}>
              {i18next.t('selectAll')}
            </span>
            <span onClick={() => setSelectedCharacter([])}>
              {i18next.t('removeAll')}
            </span>
          </div>
          <div className='memberChips'>
            {company.map((member) => (
              <span
                key={member.uid}
                className={selectedCharacter.includes(member.uid) ? 'memberChip selectedUser' : 'memberChip'}
                onClick={() => {
                  const list = [...selectedCharacter];
                  const idx = list.indexOf(member.uid);
                  if(idx > -1) { list.splice(idx, 1); } else { list.push(member.uid); }
                  setSelectedCharacter(list);
                }}
              >
                {member.name}
              </span>
            ))}
          </div>
        </div>

        {/* Étape 3 : mode d'affichage */}
        <div className='sceneStep'>
          <span className='sceneStepTitle'>{i18next.t('illustration.step3')}</span>
          <div className='modeChoice'>
            <label className={immersive ? 'modeOption' : 'modeOption selected'}>
              <input type="radio" name="displayMode" checked={!immersive} onChange={() => setImmersive(false)} />
              <span className='modeOptionTitle'>{i18next.t('illustration.modeDiscreet')}</span>
              <span className='modeOptionDesc'>{i18next.t('illustration.modeDiscreetDesc')}</span>
            </label>
            <label className={immersive ? 'modeOption selected' : 'modeOption'}>
              <input type="radio" name="displayMode" checked={immersive} onChange={() => setImmersive(true)} />
              <span className='modeOptionTitle'>{i18next.t('illustration.modeImmersive')}</span>
              <span className='modeOptionDesc'>{i18next.t('illustration.modeImmersiveDesc')}</span>
            </label>
          </div>
        </div>

        <input
          type="submit"
          className='sceneSubmit'
          value={immersive ? i18next.t('illustration.launchImmersive') : i18next.t('send')}
        />
      </form>
    </div>
  );

}

export const ImmersiveImageOverlay = ({campaignUid, characterUid}) => {
  const [urlImage, setUrlImage] = useState('');
  const [immersive, setImmersive] = useState(false);
  const [memberAvailable, setMemberAvailable] = useState([]);
  const [minimized, setMinimized] = useState(false);

  useEffect(() => {
    if(campaignUid) {
      const dbRefObject = firebase.database().ref('imagePanel').child(`${campaignUid}`);
      dbRefObject.on('value', snap => {
        const val = snap.val();
        if(val) {
          setUrlImage(val.url || '');
          setImmersive(!!val.immersive);
          setMemberAvailable(val.memberAvailable || []);
        } else {
          setImmersive(false);
        }
      });
      return () => dbRefObject.off();
    }
  }, [campaignUid]);

  // Réaffiche l'overlay quand le MJ pousse une nouvelle scène (l'image ou le flag change).
  useEffect(() => {
    if(immersive) setMinimized(false);
  }, [immersive, urlImage]);

  const active = immersive && urlImage && memberAvailable.includes(characterUid);
  if(!active) return null;

  if(minimized) {
    return (
      <button className='immersiveReopen' onClick={() => setMinimized(false)}>
        🖼 {i18next.t('illustration.reopen')}
      </button>
    );
  }

  return (
    <div className='immersiveOverlay'>
      <img src={urlImage} alt='' className='immersiveImage' />
      <button className='immersiveMinimize' onClick={() => setMinimized(true)}>
        {i18next.t('illustration.minimize')}
      </button>
    </div>
  );
}

export default ImagePanel